import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState } from 'react';
import { useMeasure } from 'react-use';
import { strToInteger } from '@/utils/numbers';
import { ButtonV2 as Button } from '@/components/Button';
import ClientOnly from '@/components/ClientOnly';
import GroupedStarReviews from '@/components/reviews/GroupedStarReviews';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import SegmentedControl, { Segment } from '@/components/SegmentedControl';
import Label from '@/components/FormElements/Label';
import Select from '@/components/FormElements/Select';
import layoutStyles from '@/components/Editor/Layout/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ContentCopyIcon = function ContentCopyIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M16.8385 3H12.1615C11.6343 2.99998 11.1795 2.99997 10.805 3.03057C10.4096 3.06287 10.0164 3.13419 9.63803 3.32698C9.07354 3.6146 8.6146 4.07354 8.32698 4.63803C8.13419 5.01641 8.06287 5.40963 8.03057 5.80497C7.99997 6.17954 7.99998 6.63429 8 7.16142V9H10V7.2C10 6.62345 10.0008 6.25118 10.0239 5.96784C10.0461 5.69618 10.0838 5.59546 10.109 5.54601C10.2049 5.35785 10.3579 5.20487 10.546 5.109C10.5955 5.0838 10.6962 5.04613 10.9678 5.02393C11.2512 5.00078 11.6234 5 12.2 5H16.8C17.3766 5 17.7488 5.00078 18.0322 5.02393C18.3038 5.04613 18.4045 5.0838 18.454 5.109C18.6422 5.20487 18.7951 5.35785 18.891 5.54601C18.9162 5.59546 18.9539 5.69618 18.9761 5.96784C18.9992 6.25118 19 6.62345 19 7.2V11.8C19 12.3766 18.9992 12.7488 18.9761 13.0322C18.9539 13.3038 18.9162 13.4045 18.891 13.454C18.7951 13.6422 18.6422 13.7951 18.454 13.891C18.4045 13.9162 18.3038 13.9539 18.0322 13.9761C17.7488 13.9992 17.3766 14 16.8 14H15V16H16.8385C17.3657 16 17.8205 16 18.195 15.9694C18.5904 15.9371 18.9836 15.8658 19.362 15.673C19.9265 15.3854 20.3854 14.9265 20.673 14.362C20.8658 13.9836 20.9371 13.5904 20.9694 13.195C21 12.8205 21 12.3657 21 11.8386V7.16148C21 6.63434 21 6.17954 20.9694 5.80497C20.9371 5.40963 20.8658 5.01641 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.9836 3.13419 18.5904 3.06287 18.195 3.03057C17.8205 2.99997 17.3657 2.99998 16.8385 3Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.16146 8H11.8385C12.3657 7.99998 12.8205 7.99997 13.195 8.03057C13.5904 8.06287 13.9836 8.13419 14.362 8.32698C14.9265 8.6146 15.3854 9.07354 15.673 9.63803C15.8658 10.0164 15.9371 10.4096 15.9694 10.805C16 11.1796 16 11.6343 16 12.1615V16.8385C16 17.3657 16 17.8205 15.9694 18.195C15.9371 18.5904 15.8658 18.9836 15.673 19.362C15.3854 19.9265 14.9265 20.3854 14.362 20.673C13.9836 20.8658 13.5904 20.9371 13.195 20.9694C12.8205 21 12.3657 21 11.8385 21H7.16148C6.63432 21 6.17955 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385V12.1615C2.99998 11.6343 2.99997 11.1795 3.03057 10.805C3.06287 10.4096 3.13419 10.0164 3.32698 9.63803C3.6146 9.07354 4.07354 8.6146 4.63803 8.32698C5.01641 8.13419 5.40963 8.06287 5.80497 8.03057C6.17955 7.99997 6.63431 7.99998 7.16146 8ZM5.96784 10.0239C5.69617 10.0461 5.59546 10.0838 5.54601 10.109C5.35785 10.2049 5.20487 10.3578 5.109 10.546C5.0838 10.5955 5.04612 10.6962 5.02393 10.9678C5.00078 11.2512 5 11.6234 5 12.2V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25117 18.9992 6.62345 19 7.2 19H11.8C12.3766 19 12.7488 18.9992 13.0322 18.9761C13.3038 18.9539 13.4045 18.9162 13.454 18.891C13.6422 18.7951 13.7951 18.6422 13.891 18.454C13.9162 18.4045 13.9539 18.3038 13.9761 18.0322C13.9992 17.7488 14 17.3766 14 16.8V12.2C14 11.6234 13.9992 11.2512 13.9761 10.9678C13.9539 10.6962 13.9162 10.5955 13.891 10.546C13.7951 10.3578 13.6422 10.2049 13.454 10.109C13.4045 10.0838 13.3038 10.0461 13.0322 10.0239C12.7488 10.0008 12.3766 10 11.8 10H7.2C6.62345 10 6.25117 10.0008 5.96784 10.0239Z",
      fill: "white"
    })]
  }));
};

ContentCopyIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 15.2413L3 12C3 11.4477 3.44772 11 4 11C4.55229 11 5 11.4477 5 12L5 15.2C5 16.0566 5.00078 16.6389 5.03755 17.089C5.07337 17.5274 5.1383 17.7516 5.21799 17.908C5.40973 18.2843 5.7157 18.5903 6.09202 18.782C6.24842 18.8617 6.47262 18.9266 6.91104 18.9625C7.36113 18.9992 7.94342 19 8.8 19H15.2C16.0566 19 16.6389 18.9992 17.089 18.9624C17.5274 18.9266 17.7516 18.8617 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C18.8617 17.7516 18.9266 17.5274 18.9625 17.089C18.9992 16.6389 19 16.0566 19 15.2L19 12C19 11.4477 19.4477 11 20 11C20.5523 11 21 11.4477 21 12V15.2411C21 16.0462 21 16.7106 20.9558 17.2518C20.9099 17.8139 20.8113 18.3306 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C18.3306 20.8113 17.8139 20.9099 17.2518 20.9558C16.7106 21 16.0463 21 15.2413 21H8.7587C7.95373 21 7.28937 21 6.74817 20.9558C6.18608 20.9099 5.66937 20.8113 5.18404 20.564C4.43139 20.1805 3.81947 19.5686 3.43597 18.816C3.18868 18.3306 3.09012 17.8139 3.04419 17.2518C2.99998 16.7106 2.99999 16.0463 3 15.2413Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.70711 7.70711C9.31658 8.09763 8.68342 8.09763 8.29289 7.70711C7.90237 7.31658 7.90237 6.68342 8.29289 6.29289L11.2929 3.29289C11.6834 2.90237 12.3166 2.90237 12.7071 3.29289L15.7071 6.29289C16.0976 6.68342 16.0976 7.31658 15.7071 7.70711C15.3166 8.09763 14.6834 8.09763 14.2929 7.70711L13 6.41421V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V6.41421L9.70711 7.70711Z",
      fill: "#12131A"
    })]
  }));
};

ShareIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ArrowDownIcon = function ArrowDownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

ArrowDownIcon.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const EditorFormFooter = _ref => {
  let {
    className,
    reviews = [],
    onCopyImage,
    onShare,
    onReviewsClick
  } = _ref;
  const [containerRef, {
    width
  }] = useMeasure();
  const isSmallContainer = width < 400;
  return /*#__PURE__*/_jsxs("footer", {
    ref: containerRef,
    className: clsx(layoutStyles.formFooter, styles.container, {
      [styles['container--small']]: isSmallContainer
    }, className),
    children: [/*#__PURE__*/_jsx(CopyImageButton, {
      buttonSize: isSmallContainer ? 'medium' : 'large',
      onCopyImage: onCopyImage
    }), /*#__PURE__*/_jsx(Button, {
      type: "button",
      size: isSmallContainer ? 'medium' : 'large',
      leftIcon: /*#__PURE__*/_jsx(ShareIcon, {}),
      onClick: onShare,
      children: "Share Options"
    }), reviews.length && onReviewsClick ? /*#__PURE__*/_jsx(ClientOnly, {
      children: /*#__PURE__*/_jsx(GroupedStarReviews, {
        reviews: reviews,
        onClick: onReviewsClick
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

const CopyImageButton = _ref2 => {
  let {
    buttonSize = 'large',
    onCopyImage
  } = _ref2;
  const nameSpace = 'editor-copy-image';
  const {
    0: fileSize,
    1: setFileSize
  } = useState('1');
  return /*#__PURE__*/_jsxs("div", {
    className: styles.copyImageContainer,
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "dark",
      size: buttonSize,
      onClick: () => onCopyImage(strToInteger(fileSize)),
      leftIcon: /*#__PURE__*/_jsx(ContentCopyIcon, {}),
      className: styles.copyImageButton,
      children: /*#__PURE__*/_jsx("span", {
        children: "Copy Image"
      })
    }), /*#__PURE__*/_jsxs(RevealPill, {
      label: "Share Options",
      placement: "top-end",
      floatingArrowHidden: true,
      noPadding: true,
      classNames: {
        floating: styles.copyImagePillFloating,
        content: styles.copyImagePillContent
      },
      OpenButton: CopyImageFieldsOpenButton,
      children: [/*#__PURE__*/_jsx(Label, {
        text: "File Type",
        caption: "Available in share options download",
        forInput: `${nameSpace}-file-type`,
        className: styles.formField,
        children: /*#__PURE__*/_jsx(Select, {
          id: `${nameSpace}-file-type`,
          defaultValue: "png",
          disabled: true,
          children: /*#__PURE__*/_jsx("option", {
            value: "png",
            children: "PNG"
          })
        })
      }), /*#__PURE__*/_jsxs(SegmentedControl, {
        defaultValue: fileSize,
        className: styles.sizeControl,
        onChange: setFileSize,
        children: [/*#__PURE__*/_jsx(Segment, {
          label: "1x Size",
          value: "1"
        }), /*#__PURE__*/_jsx(Segment, {
          label: "2x Size",
          value: "2"
        }), /*#__PURE__*/_jsx(Segment, {
          label: "3x Size",
          value: "3"
        })]
      })]
    })]
  });
};

const CopyImageFieldsOpenButton = _ref3 => {
  let {
    getReferenceProps,
    setReference
  } = _ref3;
  return /*#__PURE__*/_jsx(Button, _objectSpread({
    type: "button",
    variant: "darkLight",
    leftIcon: /*#__PURE__*/_jsx(ArrowDownIcon, {}),
    className: styles.copyImageOpenButton,
    ref: setReference
  }, getReferenceProps()));
};

export default EditorFormFooter;